module.exports = __webpack_public_path__ + "img/bot_zhjqr.ed86d0b5.png";